import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Link } from "react-router-dom"

const ActivityFeedNoResult = () => {
    return (
        <div>
            <div className={"col-12"}>
                <p className={"text-center"}>
                    <img src={"/images/launch.svg"} width={"100px"} />
                </p>
                <p className={"h1 text-center custom-lead text-custom-primary mb-0"}>
                    <FormattedMessage
                        id="dashboard.empty.get_started_title"
                        defaultMessage="Let's get started!"
                    />
                </p>
                <p className={"text-center h5 pt-3 pl-5 pr-5"}>
                    <FormattedMessage
                        id="dashboard.empty.messages_title"
                        defaultMessage="Start sending messages to customers in a {quote},
                        {order} or {invoice} and see incoming ones here."
                        values={{
                            quote: <Link to={"/quotes/listing"}>quote</Link>,
                            order: <Link to={"/orders/listing"}>order</Link>,
                            invoice: <Link to={"/invoices/listing"}>invoice</Link>
                        }}
                    />
                
                </p>
            </div> 
        </div>
    )
}

export default injectIntl(ActivityFeedNoResult)


// WEBPACK FOOTER //
// ./src/dashboard/activity-feed/ActivityFeedNoResult.tsx